<template>
    <div class="magazine-order-info-container">
        <div class="magazine-card">
            <div class="magazine-card-content">
                <div class="magazine-img">
                    <img class="magazine-img-item" v-for="item in magazineList" :key="item.id" :src="item.image"
                        alt="magazine-order-info">
                </div>
                <div class="magazine-order-info">
                    <h3>歡迎訂閱《台商》月刊</h3>
                    <p v-if="isPc != 3">《台商》月刊於2004年1月創刊，是兩岸四地唯一同步發行、同一版本的期刊，每月五日出版。<br>
                        在創刊23週年之際，為讓《台商》雜誌更上一層樓、為促進台資企業的再次轉型升級，《台商》雜誌自2026年1月起與全國台企聯（全國台灣同胞投資企業聯誼會）開始全新的合作，探索新模式，共同打造更加強有力的媒體平台。
                    </p>
                    <div class="magazine-order-price">
                        <span>￥600</span>
                        <span>HK$650</span>
                        <span>NT$2700</span>
                        <em v-if="isPc != 3">（價目为年费、含速遞郵資）</em>
                    </div>
                    <div class="tips" v-if="isPc == 3">（價目为年费、含速遞郵資）</div>
                    <button @click="toOrder">全年訂閱</button>
                    <div class="magazine-order-info-contact" v-if="isPc != 3">联系邮箱: ts960@ts960.com</div>
                </div>
            </div>
        </div>
        <img class="ts-icon" src="@/assets/images/ts-icon.png" alt="magazine-order-info">
    </div>

</template>
<script>
import { mapState } from "vuex";

export default {
    name: 'MagazineOrderInfo',
    props: {
        magazineList: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState(['isPc'])
    },
    methods: {
        toOrder() {
            this.$router.push('/order');
        }
    }
}
</script>

<style lang="less" scoped>
@property --rotate {
    syntax: "<angle>";
    initial-value: 132deg;
    inherits: false;
}

:root {
    --card-height: 65vh;
    --card-width: calc(var(--card-height) / 1.5);
}

.magazine-order-info-container {
    background: #202020;
    border-radius: 24px;
    padding: 20px;
    position: relative;



    .ts-icon {
        position: absolute;
        top: -25%;
        left: -2%;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        transform: rotate(-10deg) translateY(50%);
    }

    .magazine-card {
        width: 100%;
        height: 100%;
        padding: 6px;
        position: relative;
        border-radius: 16px;
        justify-content: center;
        align-items: center;
        text-align: center;
        display: flex;
        font-size: 1.5em;
        color: rgba(88, 199, 250, 0);
        // cursor: pointer;
        font-family: cursive;
    }

    .magazine-card:hover {
        color: rgba(88, 199, 250, 1);
        transition: color 1s;
    }

    .magazine-card:hover:before,
    .magazine-card:hover:after {
        animation: none;
        opacity: 0;
    }


    .magazine-card::before {
        content: "";
        width: 100%;
        height: 100%;
        border-radius: 16px;
        background-image: linear-gradient(var(--rotate), #B839CC, #2E3B85, #3CD5DE, );
        position: absolute;
        // z-index: -1;
        top: 0;
        left: 0;
        animation: spin 5s linear infinite;
    }

    .magazine-card::after {
        // position: absolute;
        // content: "";
        // top: 10%;
        // left: 0;
        // right: 0;
        // // z-index: -1;
        // height: 100%;
        // width: 100%;
        // margin: 0 auto;
        // transform: scale(0.8);
        // filter: blur(10px);
        // background-image: linear-gradient(var(--rotate), #5ddcff, #3c67e3 43%, #4e00c2);
        // opacity: 1;
        // transition: opacity .5s;
        // animation: spin 2.5s linear infinite;
    }

    @keyframes spin {
        0% {
            --rotate: 0deg;
        }

        100% {
            --rotate: 360deg;
        }
    }

    .magazine-card-content {
        background: #191c29;
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;
        border-radius: 16px;
        padding: 24px;

        .magazine-img {
            width: 250px;
            height: 250px;
            margin-right: 40px;
            position: relative;

            .magazine-img-item {
                position: absolute;
                top: 0%;
                left: 50%;
                width: 158px;
                height: 211px;
                box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.65);
                border-radius: 4px;
                transform: rotate(0deg) translateX(-50%);
            }

            .magazine-img-item:nth-child(1) {
                top: 0;
                left: 37%;
                transform: rotate(-10deg) translateX(-50%);

            }

            .magazine-img-item:nth-child(2) {
                transform: rotate(-2deg) translateX(-50%);
            }

            .magazine-img-item:nth-child(3) {
                top: 35px;
                left: 66%;
                transform: rotate(5deg) translateX(-50%);

            }
        }

        .magazine-order-info {
            flex: 1;
            display: flex;
            flex-direction: column;

            h3 {
                font-family: SourceHanSerifCN, SourceHanSerifCN;
                font-weight: 800;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 35px;
                text-align: left;
                font-style: normal;
                margin-bottom: 6px;
            }

            p {
                font-family: SourceHanSerifCN, SourceHanSerifCN;
                font-weight: 800;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                line-height: 20px;
                text-align: left;
                font-style: normal;
                margin-bottom: 24px;
            }

            .magazine-order-price {
                display: flex;
                gap: 10px;

                span {
                    font-family: SourceHanSerifCN, SourceHanSerifCN;
                    font-weight: 800;
                    font-size: 12px;
                    color: #FF3B30;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }

                em {
                    font-family: SourceHanSerifCN, SourceHanSerifCN;
                    font-weight: 800;
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.4);
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }
            }

            button {
                width: 200px;
                height: 50px;
                background: #E2291E;
                border-radius: 25px;
                color: #FFFFFF;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: center;
                font-style: normal;
                border: none;
                margin-top: 15px;
                cursor: pointer;
            }

            .magazine-order-info-contact {
                position: absolute;
                bottom: 14px;
                right: 14px;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: rgba(255, 255, 255, 0.4);
                line-height: 16px;
                letter-spacing: 1px;
                text-align: right;
                font-style: normal;
            }
        }
    }
}

@media (max-width: 768px) {
    .magazine-order-info-container {
        padding: 12px;

        .magazine-card-content {
            flex-direction: column;
            padding-top: 40px;
            padding-bottom: 22px;

            .magazine-img {
                .magazine-img-item {
                    box-shadow: 0px 2px 6px -4px rgba(0, 0, 0, 0.65);
                }
            }

        }

        .ts-icon {
            top: -10%;
            left: -6%;
        }

        .magazine-order-info {
            margin-top: 20px;

            button {
                margin: 20px auto;
            }
        }

        .tips {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.4);
            font-family: SourceHanSerifCN, SourceHanSerifCN;
            font-weight: 800;
            line-height: 17px;
            text-align: center;
            font-style: normal;
            margin-top: 6px;
        }

        .magazine-order-price {
            justify-content: center;
            margin-top: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/common/magazine-order-info.vue